// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2571) return "static/chunks/98f82933-1f6e50e6d17acceb.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2853":"d1fbbc227bc1c7ad","5198":"b8e3a08cb60bc349","7783":"645603c3bda00066"}[chunkId] + ".js";
};